/**
 * The $1 Unistroke Recognizer (JavaScript version)
 *
 *  Jacob O. Wobbrock, Ph.D.
 *  The Information School
 *  University of Washington
 *  Seattle, WA 98195-2840
 *  wobbrock@uw.edu
 *
 *  Andrew D. Wilson, Ph.D.
 *  Microsoft Research
 *  One Microsoft Way
 *  Redmond, WA 98052
 *  awilson@microsoft.com
 *
 *  Yang Li, Ph.D.
 *  Department of Computer Science and Engineering
 *  University of Washington
 *  Seattle, WA 98195-2840
 *  yangli@cs.washington.edu
 *
 * The academic publication for the $1 recognizer, and what should be
 * used to cite it, is:
 *
 *     Wobbrock, J.O., Wilson, A.D. and Li, Y. (2007). Gestures without
 *     libraries, toolkits or training: A $1 recognizer for user interface
 *     prototypes. Proceedings of the ACM Symposium on User Interface
 *     Software and Technology (UIST '07). Newport, Rhode Island (October
 *     7-10, 2007). New York: ACM Press, pp. 159-168.
 *     https://dl.acm.org/citation.cfm?id=1294238
 *
 * The Protractor enhancement was separately published by Yang Li and programmed
 * here by Jacob O. Wobbrock:
 *
 *     Li, Y. (2010). Protractor: A fast and accurate gesture
 *     recognizer. Proceedings of the ACM Conference on Human
 *     Factors in Computing Systems (CHI '10). Atlanta, Georgia
 *     (April 10-15, 2010). New York: ACM Press, pp. 2169-2172.
 *     https://dl.acm.org/citation.cfm?id=1753654
 *
 * This software is distributed under the "New BSD License" agreement:
 *
 * Copyright (C) 2007-2012, Jacob O. Wobbrock, Andrew D. Wilson and Yang Li.
 * All rights reserved. Last updated July 14, 2018.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *    * Redistributions of source code must retain the above copyright
 *      notice, this list of conditions and the following disclaimer.
 *    * Redistributions in binary form must reproduce the above copyright
 *      notice, this list of conditions and the following disclaimer in the
 *      documentation and/or other materials provided with the distribution.
 *    * Neither the names of the University of Washington nor Microsoft,
 *      nor the names of its contributors may be used to endorse or promote
 *      products derived from this software without specific prior written
 *      permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
 * IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
 * THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
 * PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL Jacob O. Wobbrock OR Andrew D. Wilson
 * OR Yang Li BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY,
 * OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 **/
//
// Point class
//
function Point(x, y) {
  // constructor
  this.X = x;
  this.Y = y;
}
//
// Rectangle class
//
function Rectangle(x, y, width, height) {
  // constructor
  this.X = x;
  this.Y = y;
  this.Width = width;
  this.Height = height;
}
//
// Unistroke class: a unistroke template
//
function Unistroke(name, points) {
  // constructor
  this.Name = name;
  this.Points = Resample(points, NumPoints);
  var radians = IndicativeAngle(this.Points);
  this.Points = RotateBy(this.Points, -radians);
  this.Points = ScaleTo(this.Points, SquareSize);
  this.Points = TranslateTo(this.Points, Origin);
  this.Vector = Vectorize(this.Points); // for Protractor
}
//
// Result class
//
function Result(name, score, ms) {
  // constructor
  this.Name = name;
  this.Score = score;
  this.Time = ms;
}
//
// DollarRecognizer constants
//
const NumUnistrokes = 5;
const NumPoints = 64;
const SquareSize = 250.0;
const Origin = new Point(0, 0);
const Diagonal = Math.sqrt(SquareSize * SquareSize + SquareSize * SquareSize);
const HalfDiagonal = 0.5 * Diagonal;
const AngleRange = Deg2Rad(45.0);
const AnglePrecision = Deg2Rad(2.0);
const Phi = 0.5 * (-1.0 + Math.sqrt(5.0)); // Golden Ratio
//
// DollarRecognizer class
//
export function DollarRecognizer() {
  // constructor
  //
  // one built-in unistroke per gesture type
  //
  this.Unistrokes = new Array(NumUnistrokes);
  this.Unistrokes[0] = new Unistroke("Line", [
    { X: 497.58375322818756, Y: 572.0270708799362 },
    { X: 497.858707010746, Y: 572.3907734155655 },
    { X: 498.14297074079514, Y: 572.7418262958527 },
    { X: 498.3037914633751, Y: 572.8873028755188 },
    { X: 498.63136368989944, Y: 573.1561274528503 },
    { X: 498.89935225248337, Y: 573.3395640850067 },
    { X: 499.10099881887436, Y: 573.4629009962082 },
    { X: 499.1865813732147, Y: 573.510339975357 },
    { X: 499.3272650241852, Y: 573.5862489938736 },
    { X: 499.4153302311897, Y: 573.6336879730225 },
    { X: 499.4442945122719, Y: 573.6494972705841 },
    { X: 499.5318769812584, Y: 573.6906169652939 },
    { X: 499.56091022491455, Y: 573.7001069784164 },
    { X: 499.6705607175827, Y: 573.7159162759781 },
    { X: 499.91896390914917, Y: 573.7159162759781 },
    { X: 500.36942744255066, Y: 573.6747965812683 },
    { X: 500.76582431793213, Y: 573.5894086360931 },
    { X: 502.3327919244766, Y: 573.0675798654556 },
    { X: 506.3504825234413, Y: 571.1510185003281 },
    { X: 509.74068266153336, Y: 569.1332598924637 },
    { X: 518.4110022783279, Y: 563.3266689777374 },
    { X: 529.0599960684776, Y: 554.9962999820709 },
    { X: 535.8506028056145, Y: 548.8576140403748 },
    { X: 554.7051084637642, Y: 528.8476331233978 },
    { X: 576.2966697216034, Y: 503.6983666419983 },
    { X: 594.7223660945892, Y: 480.8768141269684 },
    { X: 602.3559023737907, Y: 470.79434037208557 },
    { X: 616.3375125527382, Y: 454.0292122364044 },
    { X: 625.1485158205032, Y: 444.69629430770874 },
    { X: 628.3030708432198, Y: 441.4925501346588 },
    { X: 633.5744320750237, Y: 436.32479453086853 },
    { X: 637.9600380063057, Y: 432.11850142478943 },
    { X: 639.8584397435188, Y: 430.7111191749573 },
    { X: 643.4635272622108, Y: 429.0412538051605 },
    { X: 647.2038503885269, Y: 429.13613176345825 },
    { X: 649.5360956788063, Y: 430.00269412994385 },
    { X: 653.8685314655304, Y: 432.87752509117126 },
    { X: 657.14556401968, Y: 438.05159997940063 },
    { X: 658.1262807846069, Y: 441.8214633464813 },
    { X: 660.5312815904617, Y: 452.144291639328 },
    { X: 661.7465400695801, Y: 457.6947076320648 },
    { X: 665.7332664728165, Y: 477.13542079925537 },
    { X: 666.7966004014015, Y: 484.3209128379822 },
    { X: 669.8768827319145, Y: 498.93229579925537 },
    { X: 673.7647857666016, Y: 513.2242333889008 },
    { X: 675.4772644042969, Y: 519.3059792518616 },
    { X: 678.263490319252, Y: 530.8843717575073 },
    { X: 680.3847101330757, Y: 535.7991120815277 },
    { X: 683.7310500741005, Y: 543.8100578784943 },
    { X: 686.8398829102516, Y: 551.201137304306 },
    { X: 690.3573879599571, Y: 558.4909973144531 },
    { X: 691.9120802283287, Y: 561.0938440561295 },
    { X: 694.4523166418076, Y: 564.3893065452576 },
    { X: 696.448645234108, Y: 566.2078192234039 },
    { X: 698.466628074646, Y: 566.938395023346 },
    { X: 700.0964895486832, Y: 566.8529959917068 },
    { X: 704.3522389531136, Y: 565.3380972146988 },
    { X: 706.8856480717659, Y: 563.9402160644531 },
    { X: 711.6361349821091, Y: 560.7459619045258 },
    { X: 717.1716228723526, Y: 555.3821310997009 },
    { X: 723.9661604762077, Y: 547.434422492981 },
    { X: 727.6730367541313, Y: 542.6999702453613 },
    { X: 735.294849395752, Y: 534.0786259174347 },
    { X: 743.0936889648438, Y: 523.2940464019775 },
    { X: 747.8392795324326, Y: 516.5671348571777 },
    { X: 755.2348259687424, Y: 504.2518472671509 },
    { X: 762.7385746836662, Y: 492.183233499527 },
    { X: 766.6987504959106, Y: 486.4272301197052 },
    { X: 774.5384159088135, Y: 475.7122292518616 },
    { X: 781.9256178736687, Y: 466.69873452186584 },
    { X: 788.427478313446, Y: 458.6877887248993 },
    { X: 791.6292726993561, Y: 454.73448872566223 },
    { X: 797.4081984758377, Y: 448.4250268936157 },
    { X: 801.9526252150536, Y: 442.94101881980896 },
    { X: 803.9592981934547, Y: 440.33818316459656 },
    { X: 807.4856994152069, Y: 435.63217878341675 },
    { X: 810.5054326057434, Y: 431.5681915283203 },
    { X: 811.6760033369064, Y: 429.92047691345215 },
    { X: 813.4416521191597, Y: 427.396687746048 },
    { X: 814.6318771839142, Y: 425.6540729999542 },
    { X: 815.261367559433, Y: 424.4649167060852 },
    { X: 815.4532214403152, Y: 424.0031876564026 },
    { X: 815.7434159517288, Y: 423.27893114089966 },
    { X: 815.8761689066887, Y: 422.8583106994629 },
    { X: 815.8761689066887, Y: 422.8583106994629 },
    { X: 815.9204428792, Y: 422.731791973114 },
    { X: 815.9204428792, Y: 422.731791973114 },
    { X: 815.9204428792, Y: 422.731791973114 },
    { X: 815.8565145730972, Y: 422.7824127674103 },
    { X: 815.8565145730972, Y: 422.7824127674103 },
    { X: 815.8565145730972, Y: 422.7824127674103 },
    { X: 815.7581739425659, Y: 422.96899795532227 },
    { X: 815.7581739425659, Y: 422.96899795532227 },
    { X: 815.4974954128265, Y: 423.63631439208984 },
    { X: 815.4974954128265, Y: 423.63631439208984 },
    { X: 815.4974954128265, Y: 423.63631439208984 },
    { X: 815.2712292075157, Y: 424.5692846775055 },
    { X: 815.2712292075157, Y: 424.5692846775055 },
    { X: 815.2712292075157, Y: 424.5692846775055 },
  ]);
  this.Unistrokes[1] = new Unistroke("Pie", [
    { X: 734.6751517057419, Y: 350.9084014892578 },
    { X: 733.9703541994095, Y: 350.6806855201721 },
    { X: 733.089012503624, Y: 350.5288896560669 },
    { X: 731.543216407299, Y: 350.5288896560669 },
    { X: 730.4872614741325, Y: 350.6142554283142 },
    { X: 727.8742005825043, Y: 350.9526586532593 },
    { X: 724.3793152570724, Y: 351.6769151687622 },
    { X: 719.275188267231, Y: 353.20445251464844 },
    { X: 715.6420329809189, Y: 354.535936832428 },
    { X: 705.0531055927277, Y: 359.1565532684326 },
    { X: 690.0996748209, Y: 366.9271445274353 },
    { X: 680.9758573174477, Y: 372.4648997783661 },
    { X: 659.740901529789, Y: 388.3792748451233 },
    { X: 640.007950603962, Y: 408.0793225765228 },
    { X: 625.3713338971138, Y: 427.7509002685547 },
    { X: 620.0025285482407, Y: 437.94091272354126 },
    { X: 613.1844057440758, Y: 457.19501852989197 },
    { X: 609.5660774111748, Y: 477.46750473976135 },
    { X: 608.7973515987396, Y: 498.38830518722534 },
    { X: 609.4529098272324, Y: 508.46131110191345 },
    { X: 615.4487918615341, Y: 525.7577469348907 },
    { X: 626.3215002417564, Y: 540.808708190918 },
    { X: 639.4881107211113, Y: 554.3859014511108 },
    { X: 646.5629811882973, Y: 560.0659847259521 },
    { X: 660.5258335471153, Y: 569.8448556661606 },
    { X: 675.4315422177315, Y: 577.9664998054504 },
    { X: 683.7660140991211, Y: 579.5478065013885 },
    { X: 704.6851902604103, Y: 581.0627163648605 },
    { X: 729.1504909396172, Y: 578.2795926332474 },
    { X: 752.2346781492233, Y: 574.7121459245682 },
    { X: 762.9200841784477, Y: 570.6544890403748 },
    { X: 784.310964345932, Y: 563.1811813116074 },
    { X: 803.2953265309334, Y: 550.1353290081024 },
    { X: 819.17630392313, Y: 535.0717070102692 },
    { X: 826.2930346727371, Y: 526.779275894165 },
    { X: 836.7541054487228, Y: 509.74217462539673 },
    { X: 843.5953307151794, Y: 490.74106192588806 },
    { X: 845.8872328996658, Y: 481.4903612136841 },
    { X: 847.8594935536385, Y: 471.55970549583435 },
    { X: 846.9741520285606, Y: 439.98397064208984 },
    { X: 844.288818359375, Y: 424.9171779155731 },
    { X: 840.8116564154625, Y: 416.6500461101532 },
    { X: 833.1539142727852, Y: 399.93236804008484 },
    { X: 833.1539142727852, Y: 399.93236804008484 },
    { X: 824.5273858904839, Y: 385.91874504089355 },
    { X: 824.5273858904839, Y: 385.91874504089355 },
    { X: 824.5273858904839, Y: 385.91874504089355 },
    { X: 814.4154726266861, Y: 374.17589592933655 },
    { X: 814.4154726266861, Y: 374.17589592933655 },
    { X: 814.4154726266861, Y: 374.17589592933655 },
    { X: 809.5070614218712, Y: 369.01445960998535 },
    { X: 809.5070614218712, Y: 369.01445960998535 },
    { X: 801.3181695342064, Y: 361.1837797164917 },
    { X: 801.3181695342064, Y: 361.1837797164917 },
    { X: 801.3181695342064, Y: 361.1837797164917 },
    { X: 790.3849809765816, Y: 354.20702362060547 },
    { X: 790.3849809765816, Y: 354.20702362060547 },
    { X: 790.3849809765816, Y: 354.20702362060547 },
    { X: 785.1962369084358, Y: 351.87930965423584 },
    { X: 785.1962369084358, Y: 351.87930965423584 },
    { X: 774.6318601965904, Y: 349.2511968612671 },
    { X: 774.6318601965904, Y: 349.2511968612671 },
    { X: 774.6318601965904, Y: 349.2511968612671 },
    { X: 767.17431640625, Y: 348.3371844291687 },
    { X: 767.17431640625, Y: 348.3371844291687 },
    { X: 767.17431640625, Y: 348.3371844291687 },
    { X: 758.6043373346329, Y: 348.57439041137695 },
    { X: 758.6043373346329, Y: 348.57439041137695 },
    { X: 758.6043373346329, Y: 348.57439041137695 },
    { X: 754.6121628880501, Y: 348.6977162361145 },
    { X: 754.6121628880501, Y: 348.6977162361145 },
    { X: 749.2542536258698, Y: 349.3492012023926 },
    { X: 749.2542536258698, Y: 349.3492012023926 },
    { X: 749.2542536258698, Y: 349.3492012023926 },
    { X: 745.988530933857, Y: 350.2853422164917 },
    { X: 745.988530933857, Y: 350.2853422164917 },
    { X: 745.988530933857, Y: 350.2853422164917 },
    { X: 743.1596171855927, Y: 351.724365234375 },
    { X: 743.1596171855927, Y: 351.724365234375 },
    { X: 743.1596171855927, Y: 351.724365234375 },
    { X: 741.6870593428612, Y: 352.82813358306885 },
    { X: 741.6870593428612, Y: 352.82813358306885 },
    { X: 738.7966309785843, Y: 356.35127878189087 },
    { X: 738.7966309785843, Y: 356.35127878189087 },
    { X: 738.7966309785843, Y: 356.35127878189087 },
    { X: 736.0728851556778, Y: 362.14209365844727 },
    { X: 736.0728851556778, Y: 362.14209365844727 },
    { X: 736.0728851556778, Y: 362.14209365844727 },
    { X: 734.6603937149048, Y: 369.9094920158386 },
    { X: 734.6603937149048, Y: 369.9094920158386 },
    { X: 734.6603937149048, Y: 369.9094920158386 },
    { X: 733.9851121902466, Y: 374.9286003112793 },
    { X: 733.9851121902466, Y: 374.9286003112793 },
    { X: 733.0309460163116, Y: 385.96934366226196 },
    { X: 733.0309460163116, Y: 385.96934366226196 },
    { X: 733.0309460163116, Y: 385.96934366226196 },
    { X: 730.9318631887436, Y: 399.5781555175781 },
    { X: 730.9318631887436, Y: 399.5781555175781 },
    { X: 730.9318631887436, Y: 399.5781555175781 },
    { X: 729.8901835083961, Y: 407.247549533844 },
    { X: 729.8901835083961, Y: 407.247549533844 },
    { X: 727.7266896367073, Y: 422.36177015304565 },
    { X: 727.7266896367073, Y: 422.36177015304565 },
    { X: 727.7266896367073, Y: 422.36177015304565 },
    { X: 725.9403520822525, Y: 437.2957248687744 },
    { X: 725.9403520822525, Y: 437.2957248687744 },
    { X: 725.9403520822525, Y: 437.2957248687744 },
    { X: 726.6889408230782, Y: 449.1840727329254 },
    { X: 726.6889408230782, Y: 449.1840727329254 },
    { X: 726.6889408230782, Y: 449.1840727329254 },
    { X: 727.870269715786, Y: 454.8704752922058 },
    { X: 727.870269715786, Y: 454.8704752922058 },
    { X: 730.1232770085335, Y: 462.3501133918762 },
    { X: 730.1232770085335, Y: 462.3501133918762 },
    { X: 730.1232770085335, Y: 462.3501133918762 },
    { X: 732.9488115906715, Y: 468.7164931297302 },
    { X: 732.9488115906715, Y: 468.7164931297302 },
    { X: 732.9488115906715, Y: 468.7164931297302 },
    { X: 736.4560412168503, Y: 472.98921632766724 },
    { X: 736.4560412168503, Y: 472.98921632766724 },
    { X: 736.4560412168503, Y: 472.98921632766724 },
    { X: 738.7242892384529, Y: 474.33965849876404 },
    { X: 738.7242892384529, Y: 474.33965849876404 },
    { X: 745.6103401780128, Y: 475.5509433746338 },
    { X: 745.6103401780128, Y: 475.5509433746338 },
    { X: 745.6103401780128, Y: 475.5509433746338 },
    { X: 756.0478257536888, Y: 474.88045620918274 },
    { X: 756.0478257536888, Y: 474.88045620918274 },
    { X: 756.0478257536888, Y: 474.88045620918274 },
    { X: 769.4057384133339, Y: 472.1858911514282 },
    { X: 769.4057384133339, Y: 472.1858911514282 },
    { X: 769.4057384133339, Y: 472.1858911514282 },
    { X: 776.3778546452522, Y: 470.3610591888428 },
    { X: 776.3778546452522, Y: 470.3610591888428 },
    { X: 790.4882179498672, Y: 466.0250988006592 },
    { X: 790.4882179498672, Y: 466.0250988006592 },
    { X: 790.4882179498672, Y: 466.0250988006592 },
    { X: 804.6478205323219, Y: 461.22104573249817 },
    { X: 804.6478205323219, Y: 461.22104573249817 },
    { X: 811.3956704735756, Y: 458.54863142967224 },
    { X: 824.2420877218246, Y: 452.94444608688354 },
    { X: 834.3244850039482, Y: 448.2194616794586 },
    { X: 842.2133207321167, Y: 444.4780683517456 },
    { X: 845.5970383882523, Y: 442.91571950912476 },
    { X: 850.8694340586662, Y: 440.38878178596497 },
    { X: 850.8694340586662, Y: 440.38878178596497 },
    { X: 854.2138430476189, Y: 438.40581250190735 },
    { X: 854.2138430476189, Y: 438.40581250190735 },
    { X: 854.2138430476189, Y: 438.40581250190735 },
    { X: 855.4827544093132, Y: 437.59616804122925 },
    { X: 855.4827544093132, Y: 437.59616804122925 },
    { X: 857.2484031915665, Y: 436.327965259552 },
    { X: 857.2484031915665, Y: 436.327965259552 },
    { X: 857.2484031915665, Y: 436.327965259552 },
    { X: 858.0402314662933, Y: 435.5626001358032 },
    { X: 858.0402314662933, Y: 435.5626001358032 },
    { X: 858.0402314662933, Y: 435.5626001358032 },
    { X: 858.2664287090302, Y: 435.0850396156311 },
    { X: 858.2664287090302, Y: 435.0850396156311 },
    { X: 858.2664287090302, Y: 435.0850396156311 },
    { X: 858.2418780326843, Y: 434.93956303596497 },
    { X: 858.2418780326843, Y: 434.93956303596497 },
    { X: 858.1140214204788, Y: 434.6707384586334 },
    { X: 858.1140214204788, Y: 434.6707384586334 },
    { X: 858.1140214204788, Y: 434.6707384586334 },
    { X: 857.8976168632507, Y: 434.35763454437256 },
    { X: 857.8976168632507, Y: 434.35763454437256 },
    { X: 857.8976168632507, Y: 434.35763454437256 },
    { X: 857.7303136587143, Y: 433.92120480537415 },
    { X: 857.7303136587143, Y: 433.92120480537415 },
    { X: 857.7303136587143, Y: 433.92120480537415 },
    { X: 857.6467310190201, Y: 433.6713602542877 },
    { X: 857.6467310190201, Y: 433.6713602542877 },
    { X: 857.4500497579575, Y: 433.2222476005554 },
    { X: 857.4500497579575, Y: 433.2222476005554 },
    { X: 857.4500497579575, Y: 433.2222476005554 },
    { X: 857.2581958770752, Y: 432.77947640419006 },
    { X: 857.2581958770752, Y: 432.77947640419006 },
    { X: 857.2581958770752, Y: 432.77947640419006 },
  ]);
  this.Unistrokes[2] = new Unistroke("Bar", [
    { X: 626.8526499867439, Y: 327.6219491958618 },
    { X: 626.5619727373123, Y: 328.4189329147339 },
    { X: 626.3997038006783, Y: 328.9091320037842 },
    { X: 626.0859240889549, Y: 329.927490234375 },
    { X: 625.3958845734596, Y: 331.4993290901184 },
    { X: 624.8721138238907, Y: 332.5746273994446 },
    { X: 624.4712343811989, Y: 333.4601697921753 },
    { X: 624.0050473809242, Y: 334.6050024032593 },
    { X: 623.7797466516495, Y: 335.20593309402466 },
    { X: 623.6228567957878, Y: 335.6834936141968 },
    { X: 623.5269298553467, Y: 336.02504539489746 },
    { X: 623.2250117063522, Y: 337.2458424568176 },
    { X: 622.980056643486, Y: 338.3369278907776 },
    { X: 622.2226406931877, Y: 342.1004719734192 },
    { X: 621.1131018400192, Y: 348.4478716850281 },
    { X: 620.4048562049866, Y: 352.91035079956055 },
    { X: 618.7444443106651, Y: 364.8492751121521 },
    { X: 617.8660680055618, Y: 372.11385798454285 },
    { X: 616.1855190396309, Y: 387.7594084739685 },
    { X: 614.720340192318, Y: 404.23039054870605 },
    { X: 614.290496468544, Y: 412.19707918167114 },
    { X: 613.83361941576, Y: 427.60542368888855 },
    { X: 613.7632775902748, Y: 434.78776717185974 },
    { X: 613.7952762246132, Y: 447.99808716773987 },
    { X: 613.9452698230743, Y: 454.3644669055939 },
    { X: 614.1518127322197, Y: 465.9839680194855 },
    { X: 614.1778805851936, Y: 476.6673502922058 },
    { X: 614.2029829621315, Y: 481.72124791145325 },
    { X: 614.276290178299, Y: 491.1617045402527 },
    { X: 614.9805359840393, Y: 499.21692967414856 },
    { X: 615.3169354200363, Y: 502.9741322994232 },
    { X: 616.2976521849632, Y: 509.574547290802 },
    { X: 616.926177084446, Y: 512.6517949104309 },
    { X: 617.6772484779358, Y: 515.54243516922 },
    { X: 623.2589412927628, Y: 526.7634665966034 },
    { X: 624.4491663575172, Y: 528.0348401069641 },
    { X: 626.9692656993866, Y: 530.1727759838104 },
    { X: 628.3247250914574, Y: 531.0867884159088 },
    { X: 631.4310752749443, Y: 532.6396250724792 },
    { X: 635.1674675345421, Y: 533.7560541629791 },
    { X: 637.3791662454605, Y: 534.0470073223114 },
    { X: 642.6549410820007, Y: 534.0944352149963 },
    { X: 645.8611490726471, Y: 533.8920407295227 },
    { X: 652.1914306282997, Y: 533.2247242927551 },
    { X: 659.6513881087303, Y: 532.0925080776215 },
    { X: 663.5013617277145, Y: 531.4473202228546 },
    { X: 671.0198684334755, Y: 530.049427986145 },
    { X: 674.645644724369, Y: 529.265105009079 },
    { X: 681.1977099180222, Y: 527.7628448009491 },
    { X: 686.5570673942566, Y: 526.4313826560974 },
    { X: 688.848969578743, Y: 525.8210062980652 },
    { X: 692.6247394680977, Y: 524.7204086780548 },
    { X: 694.1267443299294, Y: 524.2301874160767 },
    { X: 696.4698167443275, Y: 523.2750663757324 },
    { X: 697.3516411781311, Y: 522.7753772735596 },
    { X: 697.3516411781311, Y: 522.7753772735596 },
    { X: 699.3740376234055, Y: 519.622231721878 },
    { X: 699.6838864684105, Y: 518.5690841674805 },
    { X: 700.1732448935509, Y: 515.5709052085876 },
    { X: 700.3871667981148, Y: 513.4266278743744 },
    { X: 700.8485264182091, Y: 507.62636733055115 },
    { X: 701.534083366394, Y: 499.52054357528687 },
    { X: 701.991029381752, Y: 494.5741846561432 },
    { X: 702.5231446027756, Y: 489.17873525619507 },
    { X: 703.4610356092453, Y: 477.44535398483276 },
    { X: 704.1589368581772, Y: 464.76636385917664 },
    { X: 704.9070428609848, Y: 451.2239599227905 },
    { X: 705.3299903273582, Y: 444.20924377441406 },
    { X: 706.4793895483017, Y: 430.46127462387085 },
    { X: 706.9461282491684, Y: 423.8576889038086 },
    { X: 707.6986478567123, Y: 411.8017358779907 },
    { X: 708.1093199849129, Y: 406.0773732662201 },
    { X: 708.7772225141525, Y: 394.64762806892395 },
    { X: 709.0078333616257, Y: 389.27430725097656 },
    { X: 709.0501763820648, Y: 379.6599040031433 },
    { X: 709.2207897901535, Y: 370.96266174316406 },
    { X: 709.1529306173325, Y: 367.354106426239 },
    { X: 708.863770544529, Y: 360.99402379989624 },
    { X: 708.6709511876106, Y: 357.98635482788086 },
    { X: 708.5986784100533, Y: 352.19243574142456 },
    { X: 709.2665809392929, Y: 346.6831283569336 },
    { X: 709.3826449513435, Y: 344.4566116333008 },
    { X: 709.0590035915375, Y: 341.06313371658325 },
    { X: 708.689640045166, Y: 339.67470932006836 },
    { X: 707.8338834643364, Y: 337.44508838653564 },
    { X: 706.7946174740791, Y: 335.49688625335693 },
    { X: 706.2536750435829, Y: 334.58287382125854 },
    { X: 705.1479980945587, Y: 332.9572877883911 },
    { X: 704.62767547369, Y: 332.2046055793762 },
    { X: 703.6130291223526, Y: 330.93635845184326 },
    { X: 702.4838359355927, Y: 329.85476303100586 },
    { X: 701.8464148640633, Y: 329.38035106658936 },
    { X: 700.5539183020592, Y: 328.58970880508423 },
    { X: 699.9105664491653, Y: 328.2576026916504 },
    { X: 698.5408318042755, Y: 327.6820378303528 },
    { X: 696.8553864955902, Y: 327.3056745529175 },
    { X: 695.8988066315651, Y: 327.18864583969116 },
    { X: 693.382638156414, Y: 327.1317057609558 },
    { X: 691.7847063541412, Y: 327.1981358528137 },
    { X: 687.6282630562782, Y: 327.51441049575806 },
    { X: 681.4981798529625, Y: 328.26709270477295 },
    { X: 677.1347109079361, Y: 329.0071806907654 },
    { X: 665.9133277535439, Y: 331.27795457839966 },
    { X: 659.6858004331589, Y: 332.5936074256897 },
    { X: 647.2225392460823, Y: 335.177463054657 },
    { X: 641.3983740210533, Y: 336.3223400115967 },
    { X: 631.2810816764832, Y: 338.23573064804077 },
    { X: 623.168393433094, Y: 339.77275800704956 },
    { X: 619.8382596969604, Y: 340.40845584869385 },
    { X: 614.4636614918709, Y: 341.45528411865234 },
    { X: 610.5201746225357, Y: 342.25860929489136 },
    { X: 608.9561724066734, Y: 342.58432960510254 },
    { X: 606.474967956543, Y: 343.11248874664307 },
    { X: 605.5036301016808, Y: 343.32122468948364 },
    { X: 604.0463129878044, Y: 343.6090292930603 },
    { X: 603.583022415638, Y: 343.6880979537964 },
    { X: 602.9692555069923, Y: 343.79248809814453 },
    { X: 602.4961032867432, Y: 343.86206674575806 },
    { X: 602.2737679481506, Y: 343.8999824523926 },
    { X: 601.91474878788, Y: 343.98224401474 },
    { X: 601.807580947876, Y: 344.0170111656189 },
    { X: 601.7042750120163, Y: 344.0613126754761 },
    { X: 601.7116540074348, Y: 344.08978271484375 },
    { X: 601.7490317225456, Y: 344.0992283821106 },
    { X: 601.9191623926163, Y: 344.10556983947754 },
    { X: 602.037226319313, Y: 344.07709980010986 },
  ]);
  this.Unistrokes[3] = new Unistroke("Scatter", [
    { X: 651.2928482890129, Y: 391.21931648254395 },
    { X: 650.5615001916885, Y: 390.9536626338959 },
    { X: 649.101769387722, Y: 390.78288674354553 },
    { X: 648.0842266082764, Y: 390.7639067173004 },
    { X: 645.349170923233, Y: 390.9694719314575 },
    { X: 643.4709062576294, Y: 391.2952365875244 },
    { X: 638.2443017363548, Y: 392.7563660144806 },
    { X: 634.748933672905, Y: 394.0309102535248 },
    { X: 634.748933672905, Y: 394.0309102535248 },
    { X: 613.8424466252327, Y: 404.94198632240295 },
    { X: 608.9414144158363, Y: 408.0287239551544 },
    { X: 598.4646201729774, Y: 416.3021750450134 },
    { X: 593.4804880619049, Y: 421.11569595336914 },
    { X: 584.7766526341438, Y: 431.43220496177673 },
    { X: 581.1421180963516, Y: 437.0142617225647 },
    { X: 575.9504086375237, Y: 447.74507188796997 },
    { X: 573.5503041744232, Y: 457.29938650131226 },
    { X: 573.3039008975029, Y: 462.19829535484314 },
    { X: 574.6117071509361, Y: 471.44267678260803 },
    { X: 578.7307037711143, Y: 481.9110038280487 },
    { X: 581.8645700216293, Y: 487.85359239578247 },
    { X: 589.5758960843086, Y: 499.5426721572876 },
    { X: 593.9959143400192, Y: 504.61869835853577 },
    { X: 603.7703937292099, Y: 513.8630797863007 },
    { X: 615.4153450131416, Y: 521.8265976905823 },
    { X: 621.9206535816193, Y: 525.5079023838043 },
    { X: 635.812198638916, Y: 530.9919104576111 },
    { X: 643.0794057250023, Y: 532.807252407074 },
    { X: 658.2437930107117, Y: 534.4518184661865 },
    { X: 673.9653978943825, Y: 533.2911322116852 },
    { X: 682.1709787249565, Y: 531.7762334346771 },
    { X: 714.6633161306381, Y: 520.0839829444885 },
    { X: 722.1587203741074, Y: 516.2192416191101 },
    { X: 735.6037327647209, Y: 507.5061900615692 },
    { X: 741.0314321517944, Y: 503.01841163635254 },
    { X: 745.853778064251, Y: 498.0372633934021 },
    { X: 754.0219811797142, Y: 487.4898898601532 },
    { X: 761.5616593956947, Y: 474.70019030570984 },
    { X: 763.878112256527, Y: 468.877779006958 },
    { X: 767.0710794329643, Y: 457.50495171546936 },
    { X: 768.1284825801849, Y: 446.23332166671753 },
    { X: 767.3548604249954, Y: 441.10354828834534 },
    { X: 764.8150377869606, Y: 430.62256050109863 },
    { X: 764.8150377869606, Y: 430.62256050109863 },
    { X: 762.8536732196808, Y: 425.5338957309723 },
    { X: 762.8536732196808, Y: 425.5338957309723 },
    { X: 758.4508956074715, Y: 415.4451026916504 },
    { X: 758.4508956074715, Y: 415.4451026916504 },
    { X: 758.4508956074715, Y: 415.4451026916504 },
    { X: 755.700116455555, Y: 411.2545967102051 },
    { X: 755.700116455555, Y: 411.2545967102051 },
    { X: 750.2000063657761, Y: 404.4928958415985 },
    { X: 750.2000063657761, Y: 404.4928958415985 },
    { X: 750.2000063657761, Y: 404.4928958415985 },
    { X: 744.0802675485611, Y: 395.9443008899689 },
    { X: 744.0802675485611, Y: 395.9443008899689 },
    { X: 744.0802675485611, Y: 395.9443008899689 },
    { X: 740.5932439565659, Y: 392.5286500453949 },
    { X: 740.5932439565659, Y: 392.5286500453949 },
    { X: 733.022601544857, Y: 386.8706953525543 },
    { X: 733.022601544857, Y: 386.8706953525543 },
    { X: 733.022601544857, Y: 386.8706953525543 },
    { X: 725.8607003092766, Y: 382.8067080974579 },
    { X: 725.8607003092766, Y: 382.8067080974579 },
    { X: 725.8607003092766, Y: 382.8067080974579 },
    { X: 722.5256012678146, Y: 380.9375967979431 },
    { X: 722.5256012678146, Y: 380.9375967979431 },
    { X: 716.2563515901566, Y: 377.72436261177063 },
    { X: 716.2563515901566, Y: 377.72436261177063 },
    { X: 716.2563515901566, Y: 377.72436261177063 },
    { X: 713.2006199359894, Y: 376.4340090751648 },
    { X: 713.2006199359894, Y: 376.4340090751648 },
    { X: 707.1463266015053, Y: 374.3435010910034 },
    { X: 707.1463266015053, Y: 374.3435010910034 },
    { X: 707.1463266015053, Y: 374.3435010910034 },
    { X: 701.3811243772507, Y: 373.05631828308105 },
    { X: 701.3811243772507, Y: 373.05631828308105 },
    { X: 701.3811243772507, Y: 373.05631828308105 },
    { X: 698.5753130912781, Y: 372.62935638427734 },
    { X: 698.5753130912781, Y: 372.62935638427734 },
    { X: 693.5380108356476, Y: 372.2087359428406 },
    { X: 693.5380108356476, Y: 372.2087359428406 },
    { X: 693.5380108356476, Y: 372.2087359428406 },
    { X: 691.3681034445763, Y: 372.1771173477173 },
    { X: 691.3681034445763, Y: 372.1771173477173 },
    { X: 687.4930274486542, Y: 372.35104179382324 },
    { X: 687.4930274486542, Y: 372.35104179382324 },
    { X: 687.4930274486542, Y: 372.35104179382324 },
    { X: 685.876889526844, Y: 372.5597777366638 },
    { X: 685.876889526844, Y: 372.5597777366638 },
    { X: 682.5251015424728, Y: 373.1480255126953 },
    { X: 682.5251015424728, Y: 373.1480255126953 },
    { X: 682.5251015424728, Y: 373.1480255126953 },
    { X: 678.815328836441, Y: 374.09682726860046 },
    { X: 678.815328836441, Y: 374.09682726860046 },
    { X: 678.815328836441, Y: 374.09682726860046 },
    { X: 677.2980142831802, Y: 374.5237891674042 },
    { X: 677.2980142831802, Y: 374.5237891674042 },
    { X: 674.281177520752, Y: 375.4883780479431 },
    { X: 674.281177520752, Y: 375.4883780479431 },
    { X: 674.281177520752, Y: 375.4883780479431 },
    { X: 672.8495144844055, Y: 375.98491859436035 },
    { X: 672.8495144844055, Y: 375.98491859436035 },
    { X: 670.2374190688133, Y: 376.99380898475647 },
    { X: 670.2374190688133, Y: 376.99380898475647 },
    { X: 670.2374190688133, Y: 376.99380898475647 },
    { X: 668.0699253678322, Y: 377.92360854148865 },
    { X: 668.0699253678322, Y: 377.92360854148865 },
    { X: 668.0699253678322, Y: 377.92360854148865 },
    { X: 667.0877603888512, Y: 378.4106590747833 },
    { X: 667.0877603888512, Y: 378.4106590747833 },
    { X: 665.3963842988014, Y: 379.3847379684448 },
    { X: 665.3963842988014, Y: 379.3847379684448 },
    { X: 665.3963842988014, Y: 379.3847379684448 },
    { X: 664.7004829645157, Y: 379.84965991973877 },
    { X: 664.7004829645157, Y: 379.84965991973877 },
    { X: 663.5501182675362, Y: 380.6845815181732 },
    { X: 663.5501182675362, Y: 380.6845815181732 },
    { X: 663.5501182675362, Y: 380.6845815181732 },
    { X: 662.632847070694, Y: 381.3803679943085 },
    { X: 662.632847070694, Y: 381.3803679943085 },
    { X: 662.632847070694, Y: 381.3803679943085 },
    { X: 662.2256230711937, Y: 381.99391508102417 },
    { X: 662.2256230711937, Y: 381.99391508102417 },
    { X: 661.5935810804367, Y: 382.7561094760895 },
    { X: 661.5935810804367, Y: 382.7561094760895 },
    { X: 661.5935810804367, Y: 382.7561094760895 },
    { X: 661.3880036473274, Y: 382.9806547164917 },
    { X: 661.3880036473274, Y: 382.9806547164917 },
    { X: 661.1578755378723, Y: 383.230521440506 },
    { X: 661.1578755378723, Y: 383.230521440506 },
    { X: 661.1578755378723, Y: 383.230521440506 },
    { X: 661.0767065882683, Y: 383.31905794143677 },
    { X: 661.0767065882683, Y: 383.31905794143677 },
    { X: 660.9444363713264, Y: 383.46455669403076 },
    { X: 660.9444363713264, Y: 383.46455669403076 },
    { X: 660.9444363713264, Y: 383.46455669403076 },
    { X: 660.9149203896523, Y: 383.483514547348 },
    { X: 660.9149203896523, Y: 383.483514547348 },
    { X: 660.8720946311951, Y: 383.29375863075256 },
    { X: 660.8720946311951, Y: 383.29375863075256 },
    { X: 660.8509231209755, Y: 382.8699674606323 },
    { X: 660.8662328124046, Y: 382.59799432754517 },
    { X: 660.9011278748512, Y: 382.06983518600464 },
  ]);
  this.Unistrokes[4] = new Unistroke("Parallel", [
    { X: 515.9897263050079, Y: 439.89224123954773 },
    { X: 516.1825456619263, Y: 440.24645376205444 },
    { X: 516.6379745006561, Y: 440.9422402381897 },
    { X: 518.3003173470497, Y: 442.87144017219543 },
    { X: 519.5043349266052, Y: 444.0005078315735 },
    { X: 523.1423175930977, Y: 447.0998840332031 },
    { X: 528.6187735199928, Y: 451.4579951763153 },
    { X: 532.1461402177811, Y: 454.16836953163147 },
    { X: 541.2320972681046, Y: 460.8794939517975 },
    { X: 547.0144711732864, Y: 465.28186225891113 },
    { X: 553.6590151786804, Y: 470.1839418411255 },
    { X: 582.4468899965286, Y: 489.14077520370483 },
    { X: 589.7785081267357, Y: 493.80564880371094 },
    { X: 606.6923379898071, Y: 504.2296965122223 },
    { X: 615.7610543966293, Y: 510.32410311698914 },
    { X: 634.9343050718307, Y: 523.3889243602753 },
    { X: 653.957079410553, Y: 535.9161186218262 },
    { X: 663.6430108547211, Y: 542.2540283203125 },
    { X: 682.2202180027962, Y: 551.9000723361969 },
    { X: 695.5092370510101, Y: 559.1519944667816 },
    { X: 701.7106965184212, Y: 563.0483543872833 },
    { X: 714.7597258090973, Y: 570.0314519405365 },
    { X: 721.5906756520271, Y: 573.1150188446045 },
    { X: 733.842980325222, Y: 578.1815550327301 },
    { X: 744.3940472602844, Y: 583.1184239387512 },
    { X: 748.4245648980141, Y: 584.8768479824066 },
    { X: 755.283030807972, Y: 587.4290961027145 },
    { X: 760.434879899025, Y: 588.7099596261978 },
    { X: 762.3485913276672, Y: 588.7826979160309 },
    { X: 764.8696561455727, Y: 587.878186583519 },
    { X: 765.9059567451477, Y: 586.8028882741928 },
    { X: 765.8754063248634, Y: 583.4663171768188 },
    { X: 752.4432209730148, Y: 567.8176070451736 },
    { X: 752.4432209730148, Y: 567.8176070451736 },
    { X: 740.311945617199, Y: 557.0551671981812 },
    { X: 733.4765821695328, Y: 551.0935986042023 },
    { X: 717.0575587749481, Y: 537.3551194667816 },
    { X: 708.1156645417213, Y: 530.1696274280548 },
    { X: 689.1873689293861, Y: 516.2065808773041 },
    { X: 670.2083858251572, Y: 501.66796946525574 },
    { X: 661.0231226682663, Y: 494.4255373477936 },
    { X: 643.7399292588234, Y: 478.6851089000702 },
    { X: 626.7783772945404, Y: 464.6967852115631 },
    { X: 618.3274276256561, Y: 457.78009557724 },
    { X: 602.4818280339241, Y: 445.4426794052124 },
    { X: 588.7270357608795, Y: 432.2355079650879 },
    { X: 582.088836312294, Y: 426.7262005805969 },
    { X: 569.1849042773247, Y: 418.8164520263672 },
    { X: 563.7374815940857, Y: 414.29073572158813 },
    { X: 554.0219652056694, Y: 407.45628547668457 },
    { X: 546.7862740159035, Y: 401.35555958747864 },
    { X: 543.8977766036987, Y: 398.5977351665497 },
    { X: 539.8407083749771, Y: 394.06884813308716 },
    { X: 538.5389018654823, Y: 392.46539068222046 },
    { X: 537.176546216011, Y: 389.87519359588623 },
    { X: 537.364400267601, Y: 387.72461915016174 },
    { X: 538.2669134736061, Y: 386.7694981098175 },
    { X: 541.5813237428665, Y: 385.48546385765076 },
    { X: 546.8713738322258, Y: 385.91874504089355 },
    { X: 550.1749569773674, Y: 386.5164828300476 },
    { X: 558.6097004413605, Y: 388.56588220596313 },
    { X: 563.9086467027664, Y: 390.4286742210388 },
    { X: 576.1884674429893, Y: 396.27953338623047 },
    { X: 583.4949831962585, Y: 400.2138533592224 },
    { X: 600.2888181805611, Y: 410.3247971534729 },
    { X: 619.9583235383034, Y: 422.532546043396 },
    { X: 641.6171922683716, Y: 435.2305383682251 },
    { X: 652.2106022238731, Y: 441.7835032939911 },
    { X: 672.7417949438095, Y: 454.4182140827179 },
    { X: 682.6972321271896, Y: 459.946501493454 },
    { X: 702.878232896328, Y: 469.9246072769165 },
    { X: 721.6477077007294, Y: 478.71989822387695 },
    { X: 730.9186223745346, Y: 482.9040627479553 },
    { X: 748.2843639850616, Y: 490.3900201320648 },
    { X: 764.8637253642082, Y: 497.64509081840515 },
    { X: 771.774395942688, Y: 501.313756942749 },
    { X: 784.7880474328995, Y: 507.939471244812 },
    { X: 791.4177644848824, Y: 511.32348132133484 },
    { X: 802.5034982562065, Y: 517.4020564556122 },
    { X: 811.4891147613525, Y: 522.1365308761597 },
    { X: 815.369569838047, Y: 524.1511187553406 },
    { X: 821.099325299263, Y: 527.889363527298 },
    { X: 824.0945767760277, Y: 529.3283643722534 },
    { X: 828.6537615060806, Y: 531.4251916408539 },
    { X: 831.2702705264091, Y: 532.6586050987244 },
    { X: 832.1948517560959, Y: 533.1045470237732 },
    { X: 834.7277781367302, Y: 533.0001790523529 },
    { X: 835.9277958869934, Y: 532.6554565429688 },
    { X: 835.9277958869934, Y: 532.6554565429688 },
    { X: 836.1688200831413, Y: 531.5991382598877 },
    { X: 835.7556653022766, Y: 531.2670543193817 },
    { X: 833.7883699536324, Y: 531.0077197551727 },
    { X: 831.5801193714142, Y: 530.3530418872833 },
    { X: 830.1341121196747, Y: 529.8438627719879 },
    { X: 826.7848067879677, Y: 528.5629992485046 },
    { X: 822.7911841273308, Y: 527.2125570774078 },
    { X: 820.4108029603958, Y: 526.6875686645508 },
    { X: 815.7581739425659, Y: 526.4155733585358 },
    { X: 813.7121233344078, Y: 526.3871033191681 },
  ]);
  // this.Unistrokes[0] = new Unistroke("triangle", new Array(new Point(137,139),new Point(135,141),new Point(133,144),new Point(132,146),new Point(130,149),new Point(128,151),new Point(126,155),new Point(123,160),new Point(120,166),new Point(116,171),new Point(112,177),new Point(107,183),new Point(102,188),new Point(100,191),new Point(95,195),new Point(90,199),new Point(86,203),new Point(82,206),new Point(80,209),new Point(75,213),new Point(73,213),new Point(70,216),new Point(67,219),new Point(64,221),new Point(61,223),new Point(60,225),new Point(62,226),new Point(65,225),new Point(67,226),new Point(74,226),new Point(77,227),new Point(85,229),new Point(91,230),new Point(99,231),new Point(108,232),new Point(116,233),new Point(125,233),new Point(134,234),new Point(145,233),new Point(153,232),new Point(160,233),new Point(170,234),new Point(177,235),new Point(179,236),new Point(186,237),new Point(193,238),new Point(198,239),new Point(200,237),new Point(202,239),new Point(204,238),new Point(206,234),new Point(205,230),new Point(202,222),new Point(197,216),new Point(192,207),new Point(186,198),new Point(179,189),new Point(174,183),new Point(170,178),new Point(164,171),new Point(161,168),new Point(154,160),new Point(148,155),new Point(143,150),new Point(138,148),new Point(136,148)));
  // this.Unistrokes[1] = new Unistroke("x", new Array(new Point(87,142),new Point(89,145),new Point(91,148),new Point(93,151),new Point(96,155),new Point(98,157),new Point(100,160),new Point(102,162),new Point(106,167),new Point(108,169),new Point(110,171),new Point(115,177),new Point(119,183),new Point(123,189),new Point(127,193),new Point(129,196),new Point(133,200),new Point(137,206),new Point(140,209),new Point(143,212),new Point(146,215),new Point(151,220),new Point(153,222),new Point(155,223),new Point(157,225),new Point(158,223),new Point(157,218),new Point(155,211),new Point(154,208),new Point(152,200),new Point(150,189),new Point(148,179),new Point(147,170),new Point(147,158),new Point(147,148),new Point(147,141),new Point(147,136),new Point(144,135),new Point(142,137),new Point(140,139),new Point(135,145),new Point(131,152),new Point(124,163),new Point(116,177),new Point(108,191),new Point(100,206),new Point(94,217),new Point(91,222),new Point(89,225),new Point(87,226),new Point(87,224)));
  // this.Unistrokes[1] = new Unistroke("Bar", new Array(new Point(78,149),new Point(78,153),new Point(78,157),new Point(78,160),new Point(79,162),new Point(79,164),new Point(79,167),new Point(79,169),new Point(79,173),new Point(79,178),new Point(79,183),new Point(80,189),new Point(80,193),new Point(80,198),new Point(80,202),new Point(81,208),new Point(81,210),new Point(81,216),new Point(82,222),new Point(82,224),new Point(82,227),new Point(83,229),new Point(83,231),new Point(85,230),new Point(88,232),new Point(90,233),new Point(92,232),new Point(94,233),new Point(99,232),new Point(102,233),new Point(106,233),new Point(109,234),new Point(117,235),new Point(123,236),new Point(126,236),new Point(135,237),new Point(142,238),new Point(145,238),new Point(152,238),new Point(154,239),new Point(165,238),new Point(174,237),new Point(179,236),new Point(186,235),new Point(191,235),new Point(195,233),new Point(197,233),new Point(200,233),new Point(201,235),new Point(201,233),new Point(199,231),new Point(198,226),new Point(198,220),new Point(196,207),new Point(195,195),new Point(195,181),new Point(195,173),new Point(195,163),new Point(194,155),new Point(192,145),new Point(192,143),new Point(192,138),new Point(191,135),new Point(191,133),new Point(191,130),new Point(190,128),new Point(188,129),new Point(186,129),new Point(181,132),new Point(173,131),new Point(162,131),new Point(151,132),new Point(149,132),new Point(138,132),new Point(136,132),new Point(122,131),new Point(120,131),new Point(109,130),new Point(107,130),new Point(90,132),new Point(81,133),new Point(76,133)));
  // this.Unistrokes[3] = new Unistroke("circle", new Array(new Point(127,141),new Point(124,140),new Point(120,139),new Point(118,139),new Point(116,139),new Point(111,140),new Point(109,141),new Point(104,144),new Point(100,147),new Point(96,152),new Point(93,157),new Point(90,163),new Point(87,169),new Point(85,175),new Point(83,181),new Point(82,190),new Point(82,195),new Point(83,200),new Point(84,205),new Point(88,213),new Point(91,216),new Point(96,219),new Point(103,222),new Point(108,224),new Point(111,224),new Point(120,224),new Point(133,223),new Point(142,222),new Point(152,218),new Point(160,214),new Point(167,210),new Point(173,204),new Point(178,198),new Point(179,196),new Point(182,188),new Point(182,177),new Point(178,167),new Point(170,150),new Point(163,138),new Point(152,130),new Point(143,129),new Point(140,131),new Point(129,136),new Point(126,139)));
  // this.Unistrokes[4] = new Unistroke("check", new Array(new Point(91,185),new Point(93,185),new Point(95,185),new Point(97,185),new Point(100,188),new Point(102,189),new Point(104,190),new Point(106,193),new Point(108,195),new Point(110,198),new Point(112,201),new Point(114,204),new Point(115,207),new Point(117,210),new Point(118,212),new Point(120,214),new Point(121,217),new Point(122,219),new Point(123,222),new Point(124,224),new Point(126,226),new Point(127,229),new Point(129,231),new Point(130,233),new Point(129,231),new Point(129,228),new Point(129,226),new Point(129,224),new Point(129,221),new Point(129,218),new Point(129,212),new Point(129,208),new Point(130,198),new Point(132,189),new Point(134,182),new Point(137,173),new Point(143,164),new Point(147,157),new Point(151,151),new Point(155,144),new Point(161,137),new Point(165,131),new Point(171,122),new Point(174,118),new Point(176,114),new Point(177,112),new Point(177,114),new Point(175,116),new Point(173,118)));
  // this.Unistrokes[5] = new Unistroke("caret", new Array(new Point(79,245),new Point(79,242),new Point(79,239),new Point(80,237),new Point(80,234),new Point(81,232),new Point(82,230),new Point(84,224),new Point(86,220),new Point(86,218),new Point(87,216),new Point(88,213),new Point(90,207),new Point(91,202),new Point(92,200),new Point(93,194),new Point(94,192),new Point(96,189),new Point(97,186),new Point(100,179),new Point(102,173),new Point(105,165),new Point(107,160),new Point(109,158),new Point(112,151),new Point(115,144),new Point(117,139),new Point(119,136),new Point(119,134),new Point(120,132),new Point(121,129),new Point(122,127),new Point(124,125),new Point(126,124),new Point(129,125),new Point(131,127),new Point(132,130),new Point(136,139),new Point(141,154),new Point(145,166),new Point(151,182),new Point(156,193),new Point(157,196),new Point(161,209),new Point(162,211),new Point(167,223),new Point(169,229),new Point(170,231),new Point(173,237),new Point(176,242),new Point(177,244),new Point(179,250),new Point(181,255),new Point(182,257)));
  // this.Unistrokes[6] = new Unistroke("zig-zag", new Array(new Point(307,216),new Point(333,186),new Point(356,215),new Point(375,186),new Point(399,216),new Point(418,186)));
  // this.Unistrokes[7] = new Unistroke("arrow", new Array(new Point(68,222),new Point(70,220),new Point(73,218),new Point(75,217),new Point(77,215),new Point(80,213),new Point(82,212),new Point(84,210),new Point(87,209),new Point(89,208),new Point(92,206),new Point(95,204),new Point(101,201),new Point(106,198),new Point(112,194),new Point(118,191),new Point(124,187),new Point(127,186),new Point(132,183),new Point(138,181),new Point(141,180),new Point(146,178),new Point(154,173),new Point(159,171),new Point(161,170),new Point(166,167),new Point(168,167),new Point(171,166),new Point(174,164),new Point(177,162),new Point(180,160),new Point(182,158),new Point(183,156),new Point(181,154),new Point(178,153),new Point(171,153),new Point(164,153),new Point(160,153),new Point(150,154),new Point(147,155),new Point(141,157),new Point(137,158),new Point(135,158),new Point(137,158),new Point(140,157),new Point(143,156),new Point(151,154),new Point(160,152),new Point(170,149),new Point(179,147),new Point(185,145),new Point(192,144),new Point(196,144),new Point(198,144),new Point(200,144),new Point(201,147),new Point(199,149),new Point(194,157),new Point(191,160),new Point(186,167),new Point(180,176),new Point(177,179),new Point(171,187),new Point(169,189),new Point(165,194),new Point(164,196)));
  // this.Unistrokes[8] = new Unistroke("left square bracket", new Array(new Point(140,124),new Point(138,123),new Point(135,122),new Point(133,123),new Point(130,123),new Point(128,124),new Point(125,125),new Point(122,124),new Point(120,124),new Point(118,124),new Point(116,125),new Point(113,125),new Point(111,125),new Point(108,124),new Point(106,125),new Point(104,125),new Point(102,124),new Point(100,123),new Point(98,123),new Point(95,124),new Point(93,123),new Point(90,124),new Point(88,124),new Point(85,125),new Point(83,126),new Point(81,127),new Point(81,129),new Point(82,131),new Point(82,134),new Point(83,138),new Point(84,141),new Point(84,144),new Point(85,148),new Point(85,151),new Point(86,156),new Point(86,160),new Point(86,164),new Point(86,168),new Point(87,171),new Point(87,175),new Point(87,179),new Point(87,182),new Point(87,186),new Point(88,188),new Point(88,195),new Point(88,198),new Point(88,201),new Point(88,207),new Point(89,211),new Point(89,213),new Point(89,217),new Point(89,222),new Point(88,225),new Point(88,229),new Point(88,231),new Point(88,233),new Point(88,235),new Point(89,237),new Point(89,240),new Point(89,242),new Point(91,241),new Point(94,241),new Point(96,240),new Point(98,239),new Point(105,240),new Point(109,240),new Point(113,239),new Point(116,240),new Point(121,239),new Point(130,240),new Point(136,237),new Point(139,237),new Point(144,238),new Point(151,237),new Point(157,236),new Point(159,237)));
  // this.Unistrokes[9] = new Unistroke("right square bracket", new Array(new Point(112,138),new Point(112,136),new Point(115,136),new Point(118,137),new Point(120,136),new Point(123,136),new Point(125,136),new Point(128,136),new Point(131,136),new Point(134,135),new Point(137,135),new Point(140,134),new Point(143,133),new Point(145,132),new Point(147,132),new Point(149,132),new Point(152,132),new Point(153,134),new Point(154,137),new Point(155,141),new Point(156,144),new Point(157,152),new Point(158,161),new Point(160,170),new Point(162,182),new Point(164,192),new Point(166,200),new Point(167,209),new Point(168,214),new Point(168,216),new Point(169,221),new Point(169,223),new Point(169,228),new Point(169,231),new Point(166,233),new Point(164,234),new Point(161,235),new Point(155,236),new Point(147,235),new Point(140,233),new Point(131,233),new Point(124,233),new Point(117,235),new Point(114,238),new Point(112,238)));
  // this.Unistrokes[10] = new Unistroke("v", new Array(new Point(89,164),new Point(90,162),new Point(92,162),new Point(94,164),new Point(95,166),new Point(96,169),new Point(97,171),new Point(99,175),new Point(101,178),new Point(103,182),new Point(106,189),new Point(108,194),new Point(111,199),new Point(114,204),new Point(117,209),new Point(119,214),new Point(122,218),new Point(124,222),new Point(126,225),new Point(128,228),new Point(130,229),new Point(133,233),new Point(134,236),new Point(136,239),new Point(138,240),new Point(139,242),new Point(140,244),new Point(142,242),new Point(142,240),new Point(142,237),new Point(143,235),new Point(143,233),new Point(145,229),new Point(146,226),new Point(148,217),new Point(149,208),new Point(149,205),new Point(151,196),new Point(151,193),new Point(153,182),new Point(155,172),new Point(157,165),new Point(159,160),new Point(162,155),new Point(164,150),new Point(165,148),new Point(166,146)));
  // this.Unistrokes[11] = new Unistroke("delete", new Array(new Point(123,129),new Point(123,131),new Point(124,133),new Point(125,136),new Point(127,140),new Point(129,142),new Point(133,148),new Point(137,154),new Point(143,158),new Point(145,161),new Point(148,164),new Point(153,170),new Point(158,176),new Point(160,178),new Point(164,183),new Point(168,188),new Point(171,191),new Point(175,196),new Point(178,200),new Point(180,202),new Point(181,205),new Point(184,208),new Point(186,210),new Point(187,213),new Point(188,215),new Point(186,212),new Point(183,211),new Point(177,208),new Point(169,206),new Point(162,205),new Point(154,207),new Point(145,209),new Point(137,210),new Point(129,214),new Point(122,217),new Point(118,218),new Point(111,221),new Point(109,222),new Point(110,219),new Point(112,217),new Point(118,209),new Point(120,207),new Point(128,196),new Point(135,187),new Point(138,183),new Point(148,167),new Point(157,153),new Point(163,145),new Point(165,142),new Point(172,133),new Point(177,127),new Point(179,127),new Point(180,125)));
  // this.Unistrokes[12] = new Unistroke("left curly brace", new Array(new Point(150,116),new Point(147,117),new Point(145,116),new Point(142,116),new Point(139,117),new Point(136,117),new Point(133,118),new Point(129,121),new Point(126,122),new Point(123,123),new Point(120,125),new Point(118,127),new Point(115,128),new Point(113,129),new Point(112,131),new Point(113,134),new Point(115,134),new Point(117,135),new Point(120,135),new Point(123,137),new Point(126,138),new Point(129,140),new Point(135,143),new Point(137,144),new Point(139,147),new Point(141,149),new Point(140,152),new Point(139,155),new Point(134,159),new Point(131,161),new Point(124,166),new Point(121,166),new Point(117,166),new Point(114,167),new Point(112,166),new Point(114,164),new Point(116,163),new Point(118,163),new Point(120,162),new Point(122,163),new Point(125,164),new Point(127,165),new Point(129,166),new Point(130,168),new Point(129,171),new Point(127,175),new Point(125,179),new Point(123,184),new Point(121,190),new Point(120,194),new Point(119,199),new Point(120,202),new Point(123,207),new Point(127,211),new Point(133,215),new Point(142,219),new Point(148,220),new Point(151,221)));
  // this.Unistrokes[13] = new Unistroke("right curly brace", new Array(new Point(117,132),new Point(115,132),new Point(115,129),new Point(117,129),new Point(119,128),new Point(122,127),new Point(125,127),new Point(127,127),new Point(130,127),new Point(133,129),new Point(136,129),new Point(138,130),new Point(140,131),new Point(143,134),new Point(144,136),new Point(145,139),new Point(145,142),new Point(145,145),new Point(145,147),new Point(145,149),new Point(144,152),new Point(142,157),new Point(141,160),new Point(139,163),new Point(137,166),new Point(135,167),new Point(133,169),new Point(131,172),new Point(128,173),new Point(126,176),new Point(125,178),new Point(125,180),new Point(125,182),new Point(126,184),new Point(128,187),new Point(130,187),new Point(132,188),new Point(135,189),new Point(140,189),new Point(145,189),new Point(150,187),new Point(155,186),new Point(157,185),new Point(159,184),new Point(156,185),new Point(154,185),new Point(149,185),new Point(145,187),new Point(141,188),new Point(136,191),new Point(134,191),new Point(131,192),new Point(129,193),new Point(129,195),new Point(129,197),new Point(131,200),new Point(133,202),new Point(136,206),new Point(139,211),new Point(142,215),new Point(145,220),new Point(147,225),new Point(148,231),new Point(147,239),new Point(144,244),new Point(139,248),new Point(134,250),new Point(126,253),new Point(119,253),new Point(115,253)));
  // this.Unistrokes[14] = new Unistroke("star", new Array(new Point(75,250),new Point(75,247),new Point(77,244),new Point(78,242),new Point(79,239),new Point(80,237),new Point(82,234),new Point(82,232),new Point(84,229),new Point(85,225),new Point(87,222),new Point(88,219),new Point(89,216),new Point(91,212),new Point(92,208),new Point(94,204),new Point(95,201),new Point(96,196),new Point(97,194),new Point(98,191),new Point(100,185),new Point(102,178),new Point(104,173),new Point(104,171),new Point(105,164),new Point(106,158),new Point(107,156),new Point(107,152),new Point(108,145),new Point(109,141),new Point(110,139),new Point(112,133),new Point(113,131),new Point(116,127),new Point(117,125),new Point(119,122),new Point(121,121),new Point(123,120),new Point(125,122),new Point(125,125),new Point(127,130),new Point(128,133),new Point(131,143),new Point(136,153),new Point(140,163),new Point(144,172),new Point(145,175),new Point(151,189),new Point(156,201),new Point(161,213),new Point(166,225),new Point(169,233),new Point(171,236),new Point(174,243),new Point(177,247),new Point(178,249),new Point(179,251),new Point(180,253),new Point(180,255),new Point(179,257),new Point(177,257),new Point(174,255),new Point(169,250),new Point(164,247),new Point(160,245),new Point(149,238),new Point(138,230),new Point(127,221),new Point(124,220),new Point(112,212),new Point(110,210),new Point(96,201),new Point(84,195),new Point(74,190),new Point(64,182),new Point(55,175),new Point(51,172),new Point(49,170),new Point(51,169),new Point(56,169),new Point(66,169),new Point(78,168),new Point(92,166),new Point(107,164),new Point(123,161),new Point(140,162),new Point(156,162),new Point(171,160),new Point(173,160),new Point(186,160),new Point(195,160),new Point(198,161),new Point(203,163),new Point(208,163),new Point(206,164),new Point(200,167),new Point(187,172),new Point(174,179),new Point(172,181),new Point(153,192),new Point(137,201),new Point(123,211),new Point(112,220),new Point(99,229),new Point(90,237),new Point(80,244),new Point(73,250),new Point(69,254),new Point(69,252)));
  // this.Unistrokes[15] = new Unistroke("pigtail", new Array(new Point(81,219),new Point(84,218),new Point(86,220),new Point(88,220),new Point(90,220),new Point(92,219),new Point(95,220),new Point(97,219),new Point(99,220),new Point(102,218),new Point(105,217),new Point(107,216),new Point(110,216),new Point(113,214),new Point(116,212),new Point(118,210),new Point(121,208),new Point(124,205),new Point(126,202),new Point(129,199),new Point(132,196),new Point(136,191),new Point(139,187),new Point(142,182),new Point(144,179),new Point(146,174),new Point(148,170),new Point(149,168),new Point(151,162),new Point(152,160),new Point(152,157),new Point(152,155),new Point(152,151),new Point(152,149),new Point(152,146),new Point(149,142),new Point(148,139),new Point(145,137),new Point(141,135),new Point(139,135),new Point(134,136),new Point(130,140),new Point(128,142),new Point(126,145),new Point(122,150),new Point(119,158),new Point(117,163),new Point(115,170),new Point(114,175),new Point(117,184),new Point(120,190),new Point(125,199),new Point(129,203),new Point(133,208),new Point(138,213),new Point(145,215),new Point(155,218),new Point(164,219),new Point(166,219),new Point(177,219),new Point(182,218),new Point(192,216),new Point(196,213),new Point(199,212),new Point(201,211)));
  //
  // The $1 Gesture Recognizer API begins here -- 3 methods: Recognize(), AddGesture(), and DeleteUserGestures()
  //
  this.Recognize = function (points, useProtractor) {
    var t0 = Date.now();
    var candidate = new Unistroke("", points);

    var u = -1;
    var b = +Infinity;
    for (
      var i = 0;
      i < this.Unistrokes.length;
      i++ // for each unistroke template
    ) {
      var d;
      if (useProtractor) {
        d = OptimalCosineDistance(this.Unistrokes[i].Vector, candidate.Vector); // Protractor
      } else
        d = DistanceAtBestAngle(
          candidate.Points,
          this.Unistrokes[i],
          -AngleRange,
          +AngleRange,
          AnglePrecision
        ); // Golden Section Search (original $1)
      if (d < b) {
        b = d; // best (least) distance
        u = i; // unistroke index
      }
    }
    var t1 = Date.now();
    return u == -1
      ? new Result("No match.", 0.0, t1 - t0)
      : new Result(
          this.Unistrokes[u].Name,
          useProtractor ? 1.0 - b : 1.0 - b / HalfDiagonal,
          t1 - t0
        );
  };
  this.AddGesture = function (name, points) {
    this.Unistrokes[this.Unistrokes.length] = new Unistroke(name, points); // append new unistroke
    var num = 0;
    for (var i = 0; i < this.Unistrokes.length; i++) {
      if (this.Unistrokes[i].Name == name) num++;
    }
    return num;
  };
  this.DeleteUserGestures = function () {
    this.Unistrokes.length = NumUnistrokes; // clear any beyond the original set
    return NumUnistrokes;
  };
}
//
// Private helper functions from here on down
//
function Resample(points, n) {
  var I = PathLength(points) / (n - 1); // interval length
  var D = 0.0;
  var newpoints = new Array(points[0]);
  for (var i = 1; i < points.length; i++) {
    var d = Distance(points[i - 1], points[i]);
    if (D + d >= I) {
      var qx =
        points[i - 1].X + ((I - D) / d) * (points[i].X - points[i - 1].X);
      var qy =
        points[i - 1].Y + ((I - D) / d) * (points[i].Y - points[i - 1].Y);
      var q = new Point(qx, qy);
      newpoints[newpoints.length] = q; // append new point 'q'
      points.splice(i, 0, q); // insert 'q' at position i in points s.t. 'q' will be the next i
      D = 0.0;
    } else D += d;
  }
  if (newpoints.length == n - 1)
    // somtimes we fall a rounding-error short of adding the last point, so add it if so
    newpoints[newpoints.length] = new Point(
      points[points.length - 1].X,
      points[points.length - 1].Y
    );
  return newpoints;
}
function IndicativeAngle(points) {
  var c = Centroid(points);
  return Math.atan2(c.Y - points[0].Y, c.X - points[0].X);
}
function RotateBy(points, radians) {
  // rotates points around centroid
  var c = Centroid(points);
  var cos = Math.cos(radians);
  var sin = Math.sin(radians);
  var newpoints = new Array();
  for (var i = 0; i < points.length; i++) {
    var qx = (points[i].X - c.X) * cos - (points[i].Y - c.Y) * sin + c.X;
    var qy = (points[i].X - c.X) * sin + (points[i].Y - c.Y) * cos + c.Y;
    newpoints[newpoints.length] = new Point(qx, qy);
  }
  return newpoints;
}
function ScaleTo(points, size) {
  // non-uniform scale; assumes 2D gestures (i.e., no lines)
  var B = BoundingBox(points);
  var newpoints = new Array();
  for (var i = 0; i < points.length; i++) {
    var qx = points[i].X * (size / B.Width);
    var qy = points[i].Y * (size / B.Height);
    newpoints[newpoints.length] = new Point(qx, qy);
  }
  return newpoints;
}
function TranslateTo(points, pt) {
  // translates points' centroid
  var c = Centroid(points);
  var newpoints = new Array();
  for (var i = 0; i < points.length; i++) {
    var qx = points[i].X + pt.X - c.X;
    var qy = points[i].Y + pt.Y - c.Y;
    newpoints[newpoints.length] = new Point(qx, qy);
  }
  return newpoints;
}
function Vectorize(points) {
  // for Protractor
  var sum = 0.0;
  var vector = new Array();
  for (var i = 0; i < points.length; i++) {
    vector[vector.length] = points[i].X;
    vector[vector.length] = points[i].Y;
    sum += points[i].X * points[i].X + points[i].Y * points[i].Y;
  }
  var magnitude = Math.sqrt(sum);
  for (var i = 0; i < vector.length; i++) vector[i] /= magnitude;
  return vector;
}
function OptimalCosineDistance(v1, v2) {
  // for Protractor
  var a = 0.0;
  var b = 0.0;
  for (var i = 0; i < v1.length; i += 2) {
    a += v1[i] * v2[i] + v1[i + 1] * v2[i + 1];
    b += v1[i] * v2[i + 1] - v1[i + 1] * v2[i];
  }
  var angle = Math.atan(b / a);
  return Math.acos(a * Math.cos(angle) + b * Math.sin(angle));
}
function DistanceAtBestAngle(points, T, a, b, threshold) {
  var x1 = Phi * a + (1.0 - Phi) * b;
  var f1 = DistanceAtAngle(points, T, x1);
  var x2 = (1.0 - Phi) * a + Phi * b;
  var f2 = DistanceAtAngle(points, T, x2);
  while (Math.abs(b - a) > threshold) {
    if (f1 < f2) {
      b = x2;
      x2 = x1;
      f2 = f1;
      x1 = Phi * a + (1.0 - Phi) * b;
      f1 = DistanceAtAngle(points, T, x1);
    } else {
      a = x1;
      x1 = x2;
      f1 = f2;
      x2 = (1.0 - Phi) * a + Phi * b;
      f2 = DistanceAtAngle(points, T, x2);
    }
  }
  return Math.min(f1, f2);
}
function DistanceAtAngle(points, T, radians) {
  var newpoints = RotateBy(points, radians);
  return PathDistance(newpoints, T.Points);
}
function Centroid(points) {
  var x = 0.0,
    y = 0.0;
  for (var i = 0; i < points.length; i++) {
    x += points[i].X;
    y += points[i].Y;
  }
  x /= points.length;
  y /= points.length;
  return new Point(x, y);
}
function BoundingBox(points) {
  var minX = +Infinity,
    maxX = -Infinity,
    minY = +Infinity,
    maxY = -Infinity;
  for (var i = 0; i < points.length; i++) {
    minX = Math.min(minX, points[i].X);
    minY = Math.min(minY, points[i].Y);
    maxX = Math.max(maxX, points[i].X);
    maxY = Math.max(maxY, points[i].Y);
  }
  return new Rectangle(minX, minY, maxX - minX, maxY - minY);
}
function PathDistance(pts1, pts2) {
  var d = 0.0;
  for (
    var i = 0;
    i < pts1.length;
    i++ // assumes pts1.length == pts2.length
  )
    d += Distance(pts1[i], pts2[i]);
  return d / pts1.length;
}
function PathLength(points) {
  var d = 0.0;
  for (var i = 1; i < points.length; i++)
    d += Distance(points[i - 1], points[i]);
  return d;
}
function Distance(p1, p2) {
  var dx = p2.X - p1.X;
  var dy = p2.Y - p1.Y;
  return Math.sqrt(dx * dx + dy * dy);
}
function Deg2Rad(d) {
  return (d * Math.PI) / 180.0;
}
